export default function IdentityService($rootScope, $location, $log, logService, skyIdentityApi, skyAuthenticationApi, skyRegistrationApi, authService, orbMessageService) {
  let identity = {};

  let refresh = () => {
    let defer = skyIdentityApi.all();
    defer.then(updatedIdentity => {
      if (updatedIdentity !== identity) {
        angular.copy(updatedIdentity, identity);
      }
    }, reason => {
      if (reason && reason.status == 401) {
        return;
      }

      logService.displayErrorMessage(reason, 'Could not load user information.');
    });

    return defer;
  };

  let ensure = () => {
    if (identity && Object.keys(identity).length > 0) {
      return $q.when(identity);
    }

    return refresh();
  };

  return {
    data: identity,
    ensure: ensure,
    refresh: refresh,

    login: data => {
      data = data || {};
      let auth = skyAuthenticationApi.login({
        email: data.email,
        password: data.password,
        persistent: data.persistent || false
      });

      auth.$promise.then(() => {
        authService.loginConfirmed();
      }, reason => {
        logService.displayErrorMessage(reason, 'Authentication failed.');
      });

      return auth.$promise;
    },

    logout: () => {
      let auth = skyAuthenticationApi.logout();

      auth.$promise.then(() => {
        if (identity !== {}) {
          angular.copy({}, identity);
        }

        $location.path('/');
        $rootScope.$broadcast('event:auth-logoutConfirmed', {});
        if (!$rootScope.$$phase) {
          $rootScope.$apply();
        }

        orbMessageService.success('You have been successfully signed out.');
        refresh();
      }, reason => {
        logService.displayErrorMessage(reason, 'An error occurred while signing out.');
      });

      return auth.$promise;
    },

    register: data => {
      data = data || {};
      let registration = skyRegistrationApi.register({
        email: data.email,
        password: data.password,
        fullName: data.fullName
      });

      registration.$promise.then(() => {
        orbMessageService.success('Thanks and welcome to SkyObserver! You can now login and get started.');
      }, reason => {
        logService.displayErrorMessage(reason, 'Account with that email already exists.');
      });

      return registration.$promise;
    }
  };
}
